/** Serializes writes and transfers; a failed operation does not block the next one. */
export class MealWriteQueue {
  private tail: Promise<void> = Promise.resolve();

  enqueue(operation: () => Promise<void>): Promise<void> {
    const result = this.tail.then(operation);
    this.tail = result.catch(() => {});
    return result;
  }

  settled(): Promise<void> {
    return this.tail;
  }
}
